import _ from 'underscore';

const convertAccountMode = accountMode => (_.isFinite(accountMode) ? Number(accountMode) : null);

/**
 * Convert a legacy ServerContext from CCUI server
 * to a new ServerContext that modern bundle uses
 * @param {Object} context - legacy server context
 * @returns {Object} - new server context
 */
export const convertLegacyContext = ({
  CurrentCustomer,
  CurrentAccount,
  CurrentUser,
  ...rest
}) => ({
  ...rest,
  CurrentAccount: CurrentAccount ? {
    Id: Number(CurrentAccount.AccountId),
    AccountNumber: CurrentAccount.AccountNumber,
    AccountMode: convertAccountMode(CurrentAccount.AccountMode),
    AdvertiserCustomerID: Number(CurrentAccount.AdvertiserCustomerId),
    CountryCode: CurrentAccount.CountryCode,
    CurrencyCode: CurrentAccount.CurrencyType,
    Name: CurrentCustomer.CustomerName,
    Number: CurrentAccount.AccountNumber,
  } : null,
  CurrentCustomer: CurrentCustomer ? {
    Id: Number(CurrentCustomer.CustomerId),
    Name: CurrentCustomer.CustomerName,
    AppScope: Number(CurrentCustomer.AppScope),
  } : null,
  CurrentUser: CurrentUser ? {
    Id: Number(CurrentUser.UserId),
    Email: CurrentUser.Email,
    Market: CurrentUser.CustomerMarket,
    Name: CurrentUser.UserName,
    LocaleID: CurrentUser.Lcid,
    IsInternal: rest.IsInternal,
  } : null,
});
